import {
  List,
  Datagrid,
  Filter,
  TextInput,
  TextField,
  DateField,
  SelectInput,
  DateInput,
  SelectField,
  ReferenceInput,
  ReferenceField,
} from "react-admin";
import { exporter } from "../utils";
import CustomActions from "../../../components/CustomActions";
import { ListPagination } from "../../../utils";
import {
  statusDeliveryAddressChoice,
  typeDocumentChoice,
} from "../../../constants/choices";

const widthSelect = { width: 200 };

const AddressesFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Documento" source="user.document" alwaysOn />

    <ReferenceInput
      sort={{ field: "name", order: "ASC" }}
      resource="sourceAddress"
      label="Origem do Endereço"
      source="sourceAddress.id"
      reference="sourceAddress"
    >
      <SelectInput
        label="Origem do Endereço"
        optionText="name"
        optionValue="id"
      />
    </ReferenceInput>
    <SelectInput
      style={widthSelect}
      label="Tipo de Documento"
      source="user.typeUserId"
      choices={typeDocumentChoice}
    />
    <SelectInput
      style={widthSelect}
      label="Status de Entrega"
      source="statusDeliveryAddressId"
      choices={statusDeliveryAddressChoice}
      optionText="name"
    />
    <ReferenceInput
      source="typeAddressId"
      reference="address/type-address"
      label="Tipo de Endereço"
      sort={{ field: "name", order: "ASC" }}
      perPage={1000}
    >
      <SelectInput
        style={widthSelect}
        label="Tipo de Endereço"
        optionText="name"
        optionValue="id"
      />
    </ReferenceInput>
    <DateInput label="De" source="createdAt.gte" />
    <DateInput label="Ate" source="createdAt.lte" />
  </Filter>
);

const AddressesList = (props) => (
  <List
    hasCreate={true}
    bulkActionButtons={<div />}
    perPage={25}
    title="Lista de Endereços"
    actions={<CustomActions />}
    exporter={exporter}
    filters={<AddressesFilter />}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField
        sortable={false}
        label="Tipo de Documento"
        source="user.typeUser.name"
      />
      <TextField sortable={false} label="Documento" source="user.document" />
      <TextField sortable={false} label="CPF" source="user.cpf" />

      <ReferenceField
        label="Origem do Endereço"
        source="sourceAddressId"
        reference="sourceAddress"
        link={false}
      >
        <TextField source="name" />
      </ReferenceField>

      <TextField label="Endereço" source="address" />
      <TextField label="Número" source="number" />
      <TextField label="Complemento" source="complement" />
      <TextField label="Bairro" source="district" />
      <TextField label="CEP" source="cep" />
      <TextField label="Cidade" source="city" />
      <TextField label="Estado (UF)" source="state" />
      <DateField label="Data de Criação" source="createdAt" />

      <ReferenceField
        label="Tipo de Endereço"
        source="typeAddressId"
        reference="address/type-address"
        link={false}
      >
        <TextField source="name" />
      </ReferenceField>
      <TextField label="Outro Tipo de Endereço" source="otherAddressType" />
      <SelectField
        label="Entrega confirmada"
        source="statusDeliveryAddressId"
        choices={[...statusDeliveryAddressChoice, { id: null, name: "Não" }]}
      />
      <TextField
        sortable={false}
        label="Alterado por"
        source="createdByUser.email"
      />
    </Datagrid>
  </List>
);

export default AddressesList;
